import Cookies from 'js-cookie';
import {
  hardcodedOfferData,
  hidPdpOfferABSkus,
  widgetVersionObj,
} from '../Constants/ProductPage';
import { getBogoPopupData } from '../datafetchers/Store';
import {
  deleteCartItemFromCookie,
  prefetchAndOpenCart,
  wait,
} from './CartUtils';
import {
  checkProductLength,
  checkStringLimit,
  getCartItems,
  getRandomEventId,
  getScreenName,
  getUserIsLoggedIn,
} from './helper';
import { fireFbAddToCart } from './productPageUtils';
import { redirectToMyloUrl } from './redirections';
import { fireGAEvent } from './useFirebase';
import { idToDetailDaiper } from '../components/StoreCategoryPage/DiaperPageRadioOptions/constant';
import { getLoginCartItems } from './getLoginCartItems';
import { addCartHandler } from './addCartHandler';
import { fireEvent } from './fireEvent';
import { bogoOfferApiParams } from '../components/StoreHomePage/BogoClothDiaper/bogoOfferApiParams';
import { getFilteredArrFromStr } from '../components/StoreHomePage/BogoClothDiaper/getFilteredArrFromStr';

export const goToCartHandler = async (id) => {
  setBuyNowClicked(false);
  setWebProductId(id);
  await prefetchAndOpenCart();
  return true;
};
const setWebProductId = (productId) => {
  Cookies.set('web_product_id', productId, '/');
};
const setBuyNowClicked = (value) => {
  Cookies.set('buy_now_clicked', value, '/');
};

export const getCartFillerItemsCookie = () => {
  return localStorage.getItem('cart_filler_products') || '';
};

export const cartItemsCookieSetter = (productId, skip, forB2G1Recovery) => {
  if (Cookies.get('cart_items')) {
    let arrCartItemIds = getCartItems();
    if (!arrCartItemIds.includes(productId) || skip) {
      arrCartItemIds.push(productId);
      if (forB2G1Recovery) Cookies.set('cart_items', productId, '/');
      else Cookies.set('cart_items', arrCartItemIds.join(','), '/');
    }
  } else {
    Cookies.set('cart_items', productId, '/');
  }
};

export const checkVarient = () => {
  if (typeof window !== 'undefined') {
    const selectedDataString = localStorage.getItem('selectedVariant');
    const data = JSON.parse(selectedDataString);
    const sizeExist = data?.hasOwnProperty('SIZE') && data.SIZE == '';
    return sizeExist;
  }
};

export const addToCartHandler = async (productId) => {
  setBuyNowClicked(false);
  if (getUserIsLoggedIn()) {
    cartItemsCookieSetter(productId);
    const apiSuccess = await addCartHandler(productId);
    await prefetchAndOpenCart();
    return apiSuccess;
  } else {
    cartItemsCookieSetter(productId);
    // await wait(10);
    const apiSuccess = await addCartHandler(productId);
    await prefetchAndOpenCart();
    await wait(100);
    return true;
  }
};
export const cartOpenHandlerForBogo = async (pageLocation) => {
  if (getUserIsLoggedIn()) {
    await prefetchAndOpenCart(pageLocation);
  } else {
    // await wait(10);
    await prefetchAndOpenCart(pageLocation);
    await wait(100);
  }
};
export const addTocartBogoHandler = async (
  params,
  forB2G1Recovery,
  option = '1',
) => {
  if (params.less) deleteCartItemFromCookie(params.productId);
  else if (!params.selectProduct)
    cartItemsCookieSetter(params.productId, true, forB2G1Recovery);
  const apiParams = bogoOfferApiParams(
    params.productId,
    params.ids,
    params.add,
    params.less,
    params.addToCart,
    params.isFirstTime,
    params.selectedProductId,
    params.changeProduct,
  );
  if (typeof window != 'undefined') {
    const value = localStorage?.getItem('option') || option || '1';
    const offerId = idToDetailDaiper[value];

    if (offerId) {
      apiParams['offerId'] = offerId;
    }
    if (value) {
      const freeProductIds =
        Cookies.get('b2g1_locked_products') || params.freebieProductIds;
      apiParams['freeProductIds'] = freeProductIds;
      apiParams['relatedProductIds'] = getFilteredArrFromStr(
        apiParams.relatedProductIds,
        freeProductIds,
      );
    }
  }

  const apiSuccess = await getBogoPopupData(apiParams);
  return apiSuccess;
};
export const buyNowHandler = async (productId) => {
  setBuyNowClicked(true);
  if (getUserIsLoggedIn()) {
    const addedToCart = await addCartHandler(productId);
    if (addedToCart) {
      setWebProductId(productId);
      cartItemsCookieSetter(productId);
      redirectToMyloUrl(`/store/placeorder`);
    }
  } else {
    setWebProductId(productId);
    cartItemsCookieSetter(productId);
    redirectToMyloUrl(`/store/placeorder`);
  }
};
export const productActionClick = (
  action,
  productData,
  text,
  showSizePopup,
) => {
  const selectedDataString = localStorage.getItem('selectedVariant');
  if (selectedDataString) {
    const data = JSON.parse(selectedDataString);
    if (data.hasOwnProperty('SIZE') && data.SIZE == '') {
      if (typeof showSizePopup === 'function') {
        showSizePopup(true);
        return true;
      }
    }
  }
  const RandomEventId = getRandomEventId();
  if (action == 'buyNow') {
    fireProductActionEvent('clicked_buy_now', productData, RandomEventId);
    fireFbAddToCart(productData, RandomEventId);
    const cart_items = getCartItems();
    const itemPresentInCart = cart_items.includes(
      productData?.id || productData?.productId,
    );
    if (itemPresentInCart) {
      goToCartHandler(productData?.id || productData?.productId);
    } else {
      addToCartHandler(productData?.id || productData?.productId);
    }
  } else {
    if (action == 'cart' && text == 1) {
      fireFbAddToCart(productData, RandomEventId);
      fireProductActionEvent('clicked_add_to_cart', productData, RandomEventId);
      return addToCartHandler(productData?.id || productData?.productId);
    } else {
      fireProductActionEvent('clicked_go_to_cart', productData);
      return goToCartHandler(productData?.id || productData?.productId);
    }
  }
};

export const goToCartForCategoryPage = (
  productData,
  fromSizePopup,
  closeModalPopup,
) => {
  fireProductActionEvent('clicked_go_to_cart', productData);
  if (fromSizePopup) {
    closeModalPopup();
  }

  return goToCartHandler(productData?.id);
};
export const getCartButton = (productId) => {
  let arrCartItemIds = getCartItems();
  if (arrCartItemIds.includes(productId)) {
    return 2;
    ('GO TO CART');
  } else {
    return 1;
    ('ADD TO CART');
  }
};

export const fireProductActionEvent = (
  eventCategory,
  productData,
  RandomEventId,
) => {
  const pricingParam =
    productData?.strikeprice +
    ', ' +
    productData?.price +
    ', ' +
    (productData?.booster_discount_price || 0) +
    ', ' +
    'NA';
  const conversionParam =
    productData?.price +
    ', ' +
    productData?.delivery +
    ', ' +
    (productData?.price + productData?.delivery);
  const nickname = productData?.nickname
    ? checkProductLength(productData?.nickname)
    : checkProductLength(productData?.name);
  fireEvent({
    category: eventCategory,
    id: productData?.id?.toString(),
    sku_name: checkStringLimit(productData?.name),
    term_id: productData?.offers?.[0]?.term_id,
    offer_id: productData?.offers?.[0]?.offer_id,
    offer_name: productData?.offers?.[0]?.name,
    screen_name: getScreenName(),
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    trust_tag: productData?.signal?.name || '',
    selling_price: productData?.price,
    pdp_variant:
      productData?.widgets?.[0]?.version == widgetVersionObj.aPlusPlus
        ? productData?.isfashionReady
          ? 'aplus_plus_fashion_ready'
          : 'aplus_plus'
        : productData?.isfashionReady
          ? 'aplus_fashion_ready'
          : 'aplus',
    sku_nickname: nickname,
    event_id: RandomEventId,
  });
  fireGAEvent({
    category: 'add_to_cart',
    currency: 'INR',
    value: productData?.price,
    items: [
      {
        item_id: productData?.id,
        item_name: checkStringLimit(productData?.name),
        item_brand: 'Mylo Family',
        quantity: 1,
        price: productData?.price,
      },
    ],
  });
};
export const getItems = async () => {
  if (getUserIsLoggedIn()) {
    const response = await getLoginCartItems();
    return response;
  } else {
    const cartItemsArr = getCartItems();
    return cartItemsArr;
  }
};

const removeFirst10Offer = (offerList) => {
  const removeOfferId = 6013;
  const removedOfferList = offerList?.filter(
    (element) => element?.term_id !== removeOfferId,
  );
  return removedOfferList;
};

export const manipulatedData = (productId, offerList) => {
  const skuPresent = hidPdpOfferABSkus?.indexOf(productId);
  const forSku = hardcodedOfferData.map(
    (element) => element?.forSku?.indexOf(productId) > -1,
  );
  let offerListNew = null;
  const isIdPresent = forSku?.indexOf(true);
  const showHardCodedDesign = isIdPresent !== -1;
  if (showHardCodedDesign) {
    const data = [hardcodedOfferData[isIdPresent]];
    offerListNew = [...data, ...offerList];
  } else if (skuPresent !== -1) {
    offerListNew = removeFirst10Offer(offerList);
  } else {
    offerListNew = offerList;
  }
  return offerListNew;
};
